import React, { Component } from "react";
import { DataGrid, GridColumn, Panel, ButtonGroup } from "rc-easyui";
import MyNavbar from "../../../components/Navbar/MyNavbar";
import { Link } from "react-router-dom";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";

const axios = require("axios");

export default class ViewUserGroupPage extends Component {
  constructor(props) {
    super(props);
    this.getViewList = this.getViewList.bind(this);
    this.state = {
      data: null,
      editingRow: null,
      total: 0,
      pageSize: 20,
      loading: false,
      pagePosition: "bottom",
      pageOptions: {
        layout: [
          "list",
          "sep",
          "first",
          "prev",
          "next",
          "last",
          "sep",
          "refresh",
          "sep",
          "manual",
          "info",
        ],
        pageList: [10, 20, 30, 40],
      },
      errors: {},
      isLoading: false,
      permissions: [],
    };
  }

  componentDidMount() {
    var data = getCookie("permission");
    this.setState({ permissions: JSON.parse(data) });
    setTitle("View User Group");
    this.getViewList();
  }

  async getViewList() {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    if (JSON.stringify(token) === "null") {
      const resp = await getAccessToken();
      if (resp) {
        this.getUserRole();
      }
    } else {
      this.getUserRole();
    }
  }

  getUserRole() {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let apiUrl = `${API_URL}api/roles`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

    let self = this;
    self.setState({ isLoading: true })
    axios
      .get(apiUrl, headersConfig)
      .then(function (response) {
        //console.log("response",response);
        self.handleResponse(response);
      })
      .catch(function (error) {
        //console.log("error",error);
        let response = error["response"];
        if (response !== undefined) {
          if (response.status === 400) {
            var message = "";
            response.data.errors.forEach((row, i) => {
              message +=
                "<p style='margin-bottom:3px;'>" + row.defaultMessage + "</p>";
            });
            alert(message);
          } else {
            alert("Uncaught Error");
          }
        } else {
          alert("Internal Server Error");
        }
        self.setState({
          isLoading: false,
        });
      });
  }

  handleResponse(response) {
    //console.log("view response",response);
    if (response.status === 200) {
      if (response.data !== "") {
        if (response.data.status === true) {
          this.setState({
            data: response.data.object,
            isLoading: false,
          });
        } else if (response.data.status === false) {
          this.setState({
            data: null,
            isLoading: false,
          });
        } else {
          alert("Internal Server Error!!");
        }
      } else {
        alert("Internal Server Error!!");
      }
    }
  }

  getError(name) {
    const { errors } = this.state;
    if (!errors) {
      return null;
    }
    return errors[name] && errors[name].length ? errors[name][0] : null;
  }

  async deleteRow(row) {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    if (JSON.stringify(token) === "null") {
      const resp = await getAccessToken();
      if (resp) {
        this.deleteRoleData(row.id);
      }
    } else {
      this.deleteRoleData(row.id);
    }
  }

  deleteRoleData(id) {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let apiUrl = `${API_URL}api/role/${id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    let self = this;
    axios
      .delete(apiUrl, headersConfig)
      .then(function (response) {
        //console.log("response",response);
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.status === true) {
              self.setState({
                isLoading: false,
              });
              alert(`${response.data.message}`);
              self.getViewList();
            } else {
              self.setState({
                isLoading: false,
              });
              alert(`${response.data.message}`);
            }
          } else {
            alert("Internal Server Error!!");
          }
        }
      })
      .catch(function (error) {
        //console.log("error",error);
        let response = error["response"];
        if (response !== undefined) {
          if (response.status === 400) {
            var message = "";
            response.data.errors.forEach((row, i) => {
              message +=
                "<p style='margin-bottom:3px;'>" + row.defaultMessage + "</p>";
            });
            alert(message);
          } else {
            alert("Uncaught Error");
          }
        } else {
          alert("Internal Server Error");
        }
        self.setState({
          isLoading: false,
        });
      });
  }

  handlePageChange(event) {
    //const { refresh, pageNumber, pageSize } = event
    this.setState((prevState) => ({
      ...prevState.pageOptions,
      //loading: true
    }));
  }

  render() {
    const { permissions, isLoading } = this.state;
    return (
      <div>
        <div
          className='loadingmodel'
          style={{ display: isLoading ? "block" : "none" }}
        ></div>
        <MyNavbar />
        <div className='container-fluid' style={{ marginTop: "10px" }}>
          <div className='row'>
            {permissions.includes("create-user-group-view") ? (
              <div className='col-12'>
                <Panel
                  title='View User Group'
                //bodyStyle={{ padding: 20 }}
                // style={{ height: 200 }}
                >
                  <DataGrid
                    data={this.state.data}
                    style={{ height: 500 }}
                    pagination
                    {...this.state}
                    onPageChange={this.handlePageChange.bind(this)}
                  >
                    <GridColumn
                      field='rn'
                      align='center'
                      width='50px'
                      cellCss='datagrid-td-rownumber'
                      title='S.No.'
                      render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                    />
                    <GridColumn field='name' title='Name' sortable></GridColumn>
                    <GridColumn
                      field='description'
                      title='Description'
                      sortable
                    ></GridColumn>
                    <GridColumn
                      field='enabled'
                      title='Status'
                      align='center'
                      render={({ row }) => (
                        <span>{row.enabled ? "Active" : "Inactive"}</span>
                      )}
                    ></GridColumn>
                    <GridColumn
                      field='act'
                      title='Actions'
                      align='center'
                      width={150}
                      render={({ row }) => (
                        <ButtonGroup>
                          {permissions.includes("create-user-group-edit") ? (
                            <Link to={`/create-user-group?id=${row.id}`}>
                              Edit ||{" "}
                            </Link>
                          ) : (
                            ""
                          )}
                          {permissions.includes("create-user-group-delete") ? (
                            <Link onClick={() => this.deleteRow(row)}>
                              {" "}
                              Delete
                            </Link>
                          ) : (
                            ""
                          )}
                        </ButtonGroup>
                      )}
                    />
                  </DataGrid>
                </Panel>
              </div>
            ) : (
              <div>You are not allowed to access this module.</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
